const getItemIdentifier = (id, type) => `${type}-${id}`;

export default getItemIdentifier;
